import type { Reference, Resource } from '@medplum/fhirtypes'
import type { ExtendedResource } from '@seen/core/ExtendedResource'
import { generateMedplumAppLink } from '@seen/core/utilsExtendedResource'
import { ContextMenuItem } from '@seen/ui'
import { IconExternalLink } from '@tabler/icons-react'
import type { ReactNode } from 'react'
import { useCurrentPractitionerPerms } from '#src/hooks/useCurrentPractitionerPerms.ts'
import { usePortalStore } from '#src/hooks/usePortalStore.ts'

export interface ContextMenuMedplumLinkItemProps {
  to: Resource | Reference | ExtendedResource<any>
  pathSuffix?: string
}

export function ContextMenuMedplumLinkItem({
  to,
  pathSuffix,
}: ContextMenuMedplumLinkItemProps): ReactNode {
  const showLinkOverlay = usePortalStore((state) => state.showLinkOverlay)
  const { isTech } = useCurrentPractitionerPerms()
  if (!showLinkOverlay && !isTech) {
    return null
  }

  const url = generateMedplumAppLink(to, pathSuffix)

  return (
    <ContextMenuItem asChild>
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        className="flex items-center gap-2"
      >
        <IconExternalLink className="-mt-px size-4 text-foreground-secondary" />
        Open in Medplum
      </a>
    </ContextMenuItem>
  )
}
